module.exports = __webpack_public_path__ + "static/media/Teamwork.47c60cde.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Teamwork.png
// module id = 755
// module chunks = 0